import React from 'react'

import cn from 'clsx'

import styles from './EditProfileSection.module.scss'

interface Props {
  title?: string
  icon?: React.ReactNode
  appendTitle?: React.ReactNode
  children?: React.ReactNode
  direction?: 'horizontal' | 'vertical'
}

const EditProfileSection: React.FC<Props> = ({
  title,
  icon,
  appendTitle,
  children,
  direction = 'vertical'
}) => {
  return (
    <section className={styles.EditProfileSection}>
      {(title || icon || appendTitle) && (
        <h2 className={styles.title}>
          <div className={styles.leading}>
            {icon}
            {title}
          </div>
          {appendTitle}
        </h2>
      )}

      <div
        className={cn({
          [styles.horizontal]: direction === 'horizontal',
          [styles.vertical]: direction === 'vertical'
        })}
      >
        {children}
      </div>
    </section>
  )
}

export { EditProfileSection }
